import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import LoginContent from './LoginContent';
import RegisterContent from './RegisterContent';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';


export default function Login({ setToken,setUser }) {
     
    const location = useLocation();
    const [currentForm, setCurrentForm] = useState(true); // default to login

    // Reset to login if coming from Navbar
    useEffect(() => {
        if (location.state?.forceLogin) {
            setCurrentForm(true);
        }
    }, [location.state]);

    const toggleForm = () => {
        setCurrentForm((prev) => !prev);
    };
     return (
          <>
               <Navbar />
               <div className="login">

                 {currentForm ? <LoginContent onToggle={toggleForm} setToken={setToken} setUser={setUser} /> : <RegisterContent onToggle={toggleForm} />}

               </div>
               <Footer />
          </>
     )
}
